var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vendor logos / Mastercard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element / Logotypes / Payment / 24 / Mastercard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base / logos / ecomm / mastercard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6927 27.9936V28.5333H52.6031V27.9936H52.4399V27.8837H52.8559V27.9936H52.6927ZM53.4999 27.8827V28.5333H53.4103V28.0416L53.2727 28.4661H53.1791L53.0415 28.0427V28.5333H52.9511V27.8827H53.0791L53.2255 28.3296L53.3727 27.8827H53.4999Z",
    fill: "#F79410"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M38.0333 30.1333H26.8333V9.86667H38.0333V30.1333Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M27.4259 20C27.4259 15.8192 29.3747 12.095 32.4094 9.695C30.1902 7.94 27.3893 6.8925 24.3454 6.8925C17.1393 6.8925 11.2979 12.7608 11.2979 20C11.2979 27.2392 17.1393 33.1075 24.3454 33.1075C27.3893 33.1075 30.1902 32.06 32.4094 30.305C29.3747 27.905 27.4259 24.1808 27.4259 20Z",
    fill: "#EB001B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    d: "M54.0333 20C54.0333 27.2392 48.1116 33.1075 40.8065 33.1075C37.7207 33.1075 34.8814 32.06 32.6309 30.305C35.7082 27.905 37.6837 24.1808 37.6837 20C37.6837 15.8192 35.7082 12.095 32.6309 9.695C34.8814 7.94 37.7207 6.8925 40.8065 6.8925C48.1116 6.8925 54.0333 12.7608 54.0333 20Z",
    fill: "#F79E1B"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.207e2d859357d61f14d90c4c375451de.svg";
export { ForwardRef as ReactComponent };